import { NgModule } from '@angular/core';
import { EsiFactoryComponent } from './esi-factory.component';
import { SiteHeaderComponent } from '../site-header/site-header.component';
import { CommonModule } from '@angular/common';
import { SiteFooterComponent } from '../site-footer/site-footer.component';
import { EsiHeaderComponent } from './warapper/esi-header.component';
import { EsiFooterComponent } from './warapper/esi-footer.component';
import { SiteHeaderService } from '../site-header/site-header.service';
import { HeaderMenuComponent } from '../site-header/header-menu/header-menu.component';
import { EsiShellModule } from './esi-shell.module';
import { StickyHeaderComponent } from '../site-header/sticky-header/sticky-header.component';
import { HeaderSubLinksComponent } from '../site-header/sticky-header/header-sub-links/header-sub-links.component';
// import { StickyFooterComponent } from '../site-header/sticky-footer/sticky-footer.component';
import { MainMenuLinkComponent } from '../site-header/main-menu-link/main-menu-link.component';

@NgModule({
    declarations: [
        EsiFactoryComponent,
        SiteHeaderComponent,
        SiteFooterComponent,
        EsiHeaderComponent,
        EsiFooterComponent,
        HeaderMenuComponent,
        StickyHeaderComponent,
        HeaderSubLinksComponent,
        // StickyFooterComponent,

        MainMenuLinkComponent,
    ],
    imports: [CommonModule, EsiShellModule],
    providers: [SiteHeaderService],
    exports: [EsiShellModule, EsiHeaderComponent, EsiFooterComponent],
})
export class EsiFactoryModule {}
